<template>
  <b-overlay :show="showOverlay" rounded="sm">
    <b-modal
        id="modal-Editor"
        centered
        ok-only
        ok-title="ثبت"
        title="افزودن کد html"
        @ok.prevent="customButtonClick"
    >
      <b-row>
        <span class="mx-1 mb-1">کد HTML خود را در اینجا قرار دهید</span>
        <b-col cols="12">
          <textarea v-model="rawHTML" class="form-control"></textarea>
        </b-col>
      </b-row>
    </b-modal>

    <component :is="product === null ? 'div' : 'b-card'">
      <b-tabs v-if="product !== null">
        <b-tab active>
          <template #title>
            <feather-icon class="mr-0 mr-sm-50" icon="ClipboardIcon" size="16" />
            <span class="d-none d-sm-inline">اطلاعات محصول</span>
          </template>

          <b-media class="my-2">
            <template>
              <b-avatar ref="previewEl" :src="base64ImageSrc" rounded size="300px" />
            </template>
            <div class="d-flex flex-wrap mt-1">
              <b-button variant="primary" @click="$refs.refInputEl.click()">
                <input ref="refInputEl" class="d-none" type="file" @input="makeBase64Pic" />
                <span class="d-none d-sm-inline">+ عکس</span>
                <feather-icon class="d-inline d-sm-none" icon="EditIcon" />
              </b-button>
              <b-button class="ml-1" variant="outline-secondary" @click="deleteProductPic()">
                <span class="d-none d-sm-inline">حذف</span>
                <feather-icon class="d-inline d-sm-none" icon="TrashIcon" />
              </b-button>
            </div>
          </b-media>

          <div>
            <b-form>
              <b-row>
                <b-col cols="12" md="4">
                  <b-form-group label="عنوان" label-for="Title">
                    <b-form-input id="Title" v-model="product.title" />
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="4">
                  <b-form-group label="وضعیت" label-for="user-status">
                    <v-select
                        v-model="product.isFree"
                        :clearable="false"
                        :options="isFreeOptions"
                        :reduce="val => val.value"
                        input-id="user-status"
                    />
                  </b-form-group>
                </b-col>

                <b-col v-if="!product.isFree" cols="12" md="4">
                  <b-form-group label="قیمت (تومان)" label-for="price">
                    <b-form-input id="price" v-model="product.price" />
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="4">
                  <b-form-group label="قیمت قبلی (خط خورده)" label-for="beforeDiscount">
                    <b-form-input id="beforeDiscount" v-model="product.beforeDiscount" />
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="4">
                  <div class="product-categories mt-2">
                    <span class="filter-title"> نمایش محصول در باندل </span>
                    <b-form-checkbox v-model="product.showOnlyInBundle" inline name="check-button" switch />
                  </div>
                </b-col>

                <b-col cols="12">
                  <b-form-group label="تیتر" label-for="subtitle">
                    <b-form-input id="subtitle" v-model="product.subtitle" />
                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <b-form-group label="توضیحات (سئو)" label-for="seoDescription">
                    <b-form-textarea id="seoDescription" v-model="product.seoDescription" />
                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <b-form-group class="mb-2" label="توضیحات" label-for="product-content">
                    <ckEditorMain
                        ref="editorContent"
                        :defaultContent="product.description"
                        @getEditorContent="setEditorContent"
                    />
                  </b-form-group>
                  <textarea
                      v-if="showHTML"
                      id="product-content"
                      v-model="rawHTML"
                      class="form-control mb-2"
                      cols="30"
                      dir="ltr"
                      name="textArea"
                      rows="10"
                  />
                </b-col>

                <b-col v-if="categories !== null" cols="12" md="4">
                  <b-form-group label="دسته بندی" label-for="productCategoryId">
                    <v-select
                        v-model="product.productCategoryId"
                        :clearable="false"
                        :options="categories"
                        :reduce="name => name.productCategoryId"
                        input-id="productCategoryId"
                        label="name"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="4">
                  <b-form-group label="انتخاب نوع محصول" label-for="type">
                    <v-select
                        v-model="product.type"
                        :clearable="false"
                        :options="types"
                        :reduce="val => val.value"
                        input-id="type"
                    />
                  </b-form-group>
                </b-col>

                <b-col v-if="product.type === 8" cols="12">
                  <b-row>
                    <b-col v-for="(item, idx) in product.productInfos" :key="idx" cols="12">
                      <b-row>
                        <b-col cols="12" md="8">
                          <b-form-group :label="` توضیحات آیتم شماره ${idx + 1}`" label-for="seoDescription">
                            <b-form-textarea v-model="item.title" />
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" md="4">
                          <b-form-group :label="` آیکون آیتم شماره ${idx + 1}`" label-for="seoDescription">
                            <b-form-textarea v-model="item.icon" />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col v-if="product.type === 1" cols="12" md="4">
                  <b-form-group label="انتخاب دوره" label-for="type">
                    <v-select v-model="product.courseId" :options="courses" label="name" :reduce="name => name.courseId"
                              :clearable="false" input-id="productCategoryId"/>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="4">
                  <b-form-group label="نوع خدمات مالیاتی" label-for="taxServiceType">
                    <v-select
                        v-model="product.taxServiceType"
                        :clearable="true"
                        :options="taxTypes"
                        :reduce="label => label.value"
                        input-id="taxServiceType"
                        label="label"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="4">
                  <b-form-group label="یادداشت پشتیبانی" label-for="supportNote">
                    <b-form-input id="supportNote" v-model="product.supportNote" />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>

            <b-button
                :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                class="mt-1 mb-sm-0 mr-0 mr-sm-1 col-12 col-md-2"
                variant="primary"
                @click="updateProduct"
            >
              ثبت
            </b-button>
          </div>
        </b-tab>
      </b-tabs>
    </component>

    <b-card class="mt-5">
      <b-row>
        <b-col cols="12">
          <h2>ویرایش وضعیت موجودیت</h2>
          <b-row>
            <b-col cols="12">
              <b-col cols="12" md="4">
                <b-form-group label="موجودیت" label-for="isAvailable">
                  <v-select
                      v-model="isAvailable"
                      :clearable="false"
                      :options="isAvailableOptions"
                      :reduce="val => val.value"
                      input-id="isAvailable"
                  />
                </b-form-group>
                <b-button variant="primary" @click="changeProductAvailablity">
                  <span class="d-none d-sm-inline">ویرایش وضعیت</span>
                </b-button>
              </b-col>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <b-card class="mt-5">
      <b-row>
        <b-col cols="12">
          <h2>تریلر</h2>
          <b-row>
            <b-col v-if="base64Trailer === '' || base64Trailer === null" cols="12">
              <b-button class="mt-2 col-6" variant="warning" @click="$refs.refInputEl2.click()">
                <input ref="refInputEl2" class="d-none" type="file" @change="select" />
                <span class="">{{ file ? file.name : "انتخاب تریلر" }}</span>
              </b-button>
              <b-button
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  class="mt-2 mb-sm-0 ml-2 mr-sm-1 col-12 col-md-2"
                  variant="primary"
                  @click="upload"
              >
                ثبت
              </b-button>
              <b-progress
                  v-if="uploaded !== 0 && uploaded !== 100"
                  :value="uploaded"
                  class="mt-2"
                  max="100"
                  variant="primary"
              />
            </b-col>
            <b-col v-else cols="12">
              <video class="col-10" controls style="max-height: 30rem;">
                <source :src="base64Trailer" />
              </video>
              <b-button
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  class="mt-1 mb-sm-0 ml-1 mr-sm-1 col-2 col-md-2"
                  variant="danger"
                  @click="deleteTrailer"
              >
                حذف تریلر
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BAvatar,
  BButton,
  BCard,
  BCol,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BMedia,
  BModal,
  BOverlay,
  BProgress,
  BRow,
  BTab,
  BTabs
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import {
  ProductCategoryGetAllRequest,
  ProductChangeProductAvailablityRequest,
  ProductCourseGetAllRequest,
  ProductGetByIdRequest,
  ProductUpdateRequest
} from '@/libs/Api/Product'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {MediaDeleteMediaByPictureUrlRequest} from '@/libs/Api/Media'
import axios from 'axios'
import {getUserData} from '@/auth/utils'
import Helper from '@/libs/Helper'
import ckEditorMain from '@/views/components/ckEditorMain.vue'

export default {
  title: 'اطلاعات محصول - پنل ادمین لنزآوا',
  components: {
    BAvatar, BButton, BCard, BCol, BForm, BFormCheckbox, BFormGroup,
    BFormInput, BFormTextarea, BMedia, BModal, BOverlay, BProgress,
    BRow, BTab, BTabs, vSelect, ckEditorMain
  },
  directives: { Ripple },
  data() {
    return {
      product: null,
      showOverlay: false,
      productId: this.$route.params.id,
      base64ImageSrc: null,
      categories: null,
      showHTML: false,
      courses: [],
      base64Trailer: null,
      rawHTML: '',
      isFreeOptions: [
        { label: 'رایگان', value: true },
        { label: 'پولی', value: false }
      ],
      types: [
        { label: 'دوره', value: 1 },
        { label: 'فیلم', value: 2 },
        { label: 'فایل', value: 3 },
        { label: 'پادکست', value: 4 },
        { label: 'پکیج', value: 7 },
        { label: 'تست روانشناسی', value: 8 }
      ],
      isAvailableOptions: [
        { label: 'موجود', value: true },
        { label: 'ناموجود', value: false }
      ],
      taxTypes: [
        {label: 'تولید محتوای آموزشی تصویری', value: 2}
      ],
      isAvailable: null,
      userToken: getUserData().token,
      errorAlert: false,
      baseURL: Helper.baseUrl,
      file: null,
      uploaded: 0
    }
  },
  computed: {
    formData() {
      const formData = new FormData()
      if (this.file !== null) {
        formData.set('file', this.file, this.file.name)
      }
      return formData
    },
    config() {
      return {
        method: 'POST',
        data: this.formData,
        withCredentials: true,
        url: Helper.baseUrl + 'api/Product/UploadTrailer?productId=' + this.product.productId,
        headers: {
          Authorization: 'Bearer ' + this.userToken,
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
          this.uploaded = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        }
      }
    }
  },
  async created() {
    await this.getProduct()
    await this.getAllProductCategories()
    await this.getAllCourses()
  },
  methods: {
    async getAllCourses() {
      let _this = this;
      _this.overlay = true;
      let courseData = {
        pageNumber: 0,
        searchCommand: '',
        count: 0
      }
      let productCourseGetAllRequest = new ProductCourseGetAllRequest(_this);
      productCourseGetAllRequest.setParams(courseData);
      await productCourseGetAllRequest.fetch(function (content) {
        _this.courses = content.courses;
        _this.overlay = false;
      }, function (error) {
        _this.overlay = false;
      })
    },
    async getProduct() {
      this.showOverlay = true
      const productGetByIdRequest = new ProductGetByIdRequest(this)
      productGetByIdRequest.setId(this.productId)
      await productGetByIdRequest.fetch(
          (content) => {
            this.product = content.product
            this.base64ImageSrc = Helper.baseUrl + this.product.imageFile
            this.product.imageFile = ''
            if (this.product.trailerFile && this.product.trailerFile !== 'media/gallery/Trailer/') {
              this.base64Trailer = Helper.baseUrl + this.product.trailerFile
              this.product.trailerFile = ''
            } else {
              this.product.trailerFile = ''
            }
            this.isAvailable = this.product.available
            this.showOverlay = false
          },
          (error) => {
            this.showOverlay = false
            console.log(error)
          }
      )
    },
    async changeProductAvailablity() {
      this.showOverlay = true
      const data = {
        productId: this.productId,
        isAvailable: this.isAvailable
      }
      const productChangeProductAvailablityRequest = new ProductChangeProductAvailablityRequest(this)
      productChangeProductAvailablityRequest.setParams(data)
      await productChangeProductAvailablityRequest.fetch(
          () => {
            this.$toast({
              component: ToastificationContent,
              position: 'bottom-center',
              props: {
                title: 'عملیات موفق',
                icon: 'CheckIcon',
                variant: 'success',
                text: 'عملیات انجام شد.'
              }
            })
            this.showOverlay = false
            this.getProduct()
          },
          (error) => {
            this.showOverlay = false
            console.log(error)
          }
      )
    },
    async getAllProductCategories() {
      this.showOverlay = true
      const defaultGetData = {
        pageNumber: 0,
        count: 0
      }
      const productCategoryGetAllRequest = new ProductCategoryGetAllRequest(this)
      productCategoryGetAllRequest.setParams(defaultGetData)
      await productCategoryGetAllRequest.fetch(
          (content) => {
            this.showOverlay = false
            this.categories = content.productCategories
          },
          (error) => {
            this.showOverlay = false
            console.log(error)
          }
      )
    },
    async updateProduct() {
      this.showOverlay = true

      const payload = {
        ...this.product,
        supportNote: this.product.supportNote ?? '',
        trailerFile: ''
      }

      const productUpdateRequest = new ProductUpdateRequest(this)
      productUpdateRequest.setParams(payload)

      await productUpdateRequest.fetch(
          () => {
            this.showOverlay = false
            this.$toast({
              component: ToastificationContent,
              position: 'bottom-center',
              props: {
                title: 'عملیات موفق',
                icon: 'CheckIcon',
                variant: 'success',
                text: 'عملیات انجام شد.'
              }
            })
            this.getProduct()
          },
          (error) => {
            this.showOverlay = false
            console.log(error)
          }
      )
    },
    async readAsDataURL(file) {
      return new Promise((resolve, reject) => {
        const fr = new FileReader()
        fr.onerror = reject
        fr.onload = () => {
          resolve(fr.result.split(',')[1])
        }
        fr.readAsDataURL(file)
      })
    },
    async makeBase64Pic(e) {
      const file = e.target.files[0]
      this.base64ImageSrc = URL.createObjectURL(file)
      this.product.imageFile = await this.readAsDataURL(file)
    },
    deleteProductPic() {
      this.product.imageFile = ''
      this.base64ImageSrc = null
    },
    select(event) {
      this.file = event.target.files.item(0)
    },
    upload() {
      this.showOverlay = true
      axios(this.config)
          .then(() => {
            this.$toast({
              component: ToastificationContent,
              position: 'bottom-center',
              props: {
                title: 'عملیات موفق',
                icon: 'CheckIcon',
                variant: 'success',
                text: 'فایل با موفقیت آپلود شد.'
              }
            })
            this.showOverlay = false
            this.getProduct()
          })
          .catch((error) => {
            this.showOverlay = false
            console.log(error)
          })
    },
    customButtonClick() {
      this.showHTML = !this.showHTML
      const editor = document.querySelector('.ql-editor')
      if (editor.classList.contains('d-none')) {
        this.product.description = this.rawHTML
        editor.classList.remove('d-none')
      } else {
        this.rawHTML = this.product.description
        editor.classList.add('d-none')
      }
    },
    async deleteTrailer() {
      this.showOverlay = true
      const pictureUrl = this.base64Trailer.split('media/gallery/Trailer/')[1]
      const data = { pictureUrl }
      const mediaDeleteByPictureUrlRequest = new MediaDeleteMediaByPictureUrlRequest(this)
      mediaDeleteByPictureUrlRequest.setParams(data)
      await mediaDeleteByPictureUrlRequest.fetch(
          () => {
            this.showOverlay = false
            this.$toast({
              component: ToastificationContent,
              position: 'bottom-center',
              props: {
                title: 'عملیات موفق',
                icon: 'CheckIcon',
                variant: 'success',
                text: 'عملیات انجام شد.'
              }
            })
            this.getProduct()
          },
          (error) => {
            this.showOverlay = false
            console.log(error)
          }
      )
    },
    setEditorContent(content) {
      this.product.description = content
    }
  }
}
</script>

<style lang="scss">
@import '~@core/scss/base/pages/app-ecommerce-details.scss';
</style>
